import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { featuredSlides } from "@/mocks/movies";

export default function HeroCarousel() {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setIndex((prev) => (prev + 1) % featuredSlides.length);
    }, 6000);
    return () => clearInterval(timer);
  }, []);

  const go = (dir: number) => {
    setIndex((prev) => (prev + dir + featuredSlides.length) % featuredSlides.length);
  };

  const active = featuredSlides[index];

  return (
    <section className="relative h-[460px] w-full overflow-hidden md:h-[600px]">
      {featuredSlides.map((slide, i) => (
        <div
          key={slide.id}
          className={`absolute inset-0 transition-opacity duration-700 ${i === index ? "opacity-100" : "opacity-0"}`}
        >
          <img
            src={slide.backdrop}
            alt={`${slide.title} 焦点剧照`}
            title={`${slide.title} - 97影院焦点推荐`}
            className="h-full w-full object-cover object-top"
          />
        </div>
      ))}
      <div className="absolute inset-0 bg-gradient-to-t from-primary-950/90 via-primary-950/45 to-primary-950/35" />
      <div className="absolute inset-0 bg-gradient-to-r from-primary-950/70 via-transparent to-transparent" />

      <div className="relative z-10 mx-auto flex h-full w-full max-w-[1440px] flex-col justify-end px-4 pb-14 md:px-8 md:pb-20">
        <div key={active.id} className="max-w-2xl animate-fade-up">
          <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-500 px-3 py-1 text-xs font-bold text-primary-950">
            <i className="ri-fire-line" />
            {active.tag}
          </span>
          <h1 className="mt-4 font-heading text-4xl font-black leading-tight text-background-50 md:text-6xl">
            {active.title}
          </h1>
          <p className="mt-4 max-w-xl text-sm leading-relaxed text-background-200 md:text-base">{active.desc}</p>
          <div className="mt-7 flex flex-wrap items-center gap-3">
            <Link
              to={`/detail/${active.id}`}
              className="flex items-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-6 py-3 text-sm font-semibold text-primary-950 transition-colors hover:bg-accent-400"
            >
              <i className="ri-play-fill text-lg" />
              查看详情
            </Link>
            <Link
              to="/category"
              className="flex items-center gap-2 whitespace-nowrap rounded-md border border-background-50/40 bg-background-50/10 px-6 py-3 text-sm font-semibold text-background-50 backdrop-blur transition-colors hover:bg-background-50/20"
            >
              <i className="ri-function-line text-lg" />
              浏览分类
            </Link>
          </div>
        </div>

        <div className="mt-10 flex items-center gap-4">
          <div className="flex items-center gap-2">
            {featuredSlides.map((slide, i) => (
              <button
                key={slide.id}
                type="button"
                onClick={() => setIndex(i)}
                aria-label={`切换至 ${slide.title}`}
                className={`h-1.5 rounded-full transition-all ${
                  i === index ? "w-8 bg-accent-500" : "w-4 bg-background-50/50 hover:bg-background-50/80"
                }`}
              />
            ))}
          </div>
          <div className="ml-auto flex items-center gap-2">
            <button
              type="button"
              onClick={() => go(-1)}
              aria-label="上一张"
              className="flex h-9 w-9 items-center justify-center rounded-full border border-background-50/40 text-background-50 transition-colors hover:bg-background-50/20 md:h-10 md:w-10"
            >
              <i className="ri-arrow-left-s-line text-xl" />
            </button>
            <button
              type="button"
              onClick={() => go(1)}
              aria-label="下一张"
              className="flex h-9 w-9 items-center justify-center rounded-full border border-background-50/40 text-background-50 transition-colors hover:bg-background-50/20 md:h-10 md:w-10"
            >
              <i className="ri-arrow-right-s-line text-xl" />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}